// Packages
import { Component } from "react";
import { Link } from "react-router-dom";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// import ElevationScroll from './ElevationScroll';
import Mergeicon from "../../assets/images/MergeIcon.svg";
// Material Ui

// Servvices
import userService from "../../services/user.service";
import Dialog from "@material-ui/core/Dialog";

import DialogTitle from "@material-ui/core/DialogTitle";

import DialogContent from "@material-ui/core/DialogContent";
import close from "../../assets/images/crosstick.png";
// Assets
import vlrefresh from "../../assets/images/vlrefresh.png";
import vldown from "../../assets/images/vldown.png";
import vlup from "../../assets/images/vlup.png";
import vlupdown from "../../assets/images/vlupdown.png";
import vldelete from "../../assets/images/vldelete.png";
import endZoneImg from "../../assets/images/endZoneImg.png";
import vlplay from "../../assets/images/vlplay.png";
import vltight from "../../assets/images/vltight.png";
import wide from "../../assets/images/wide.png"
import { BsXLg } from "react-icons/bs";

import belen from "../../assets/images/belen.png";
import { Accordion, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

//css
import "./VideoLibrary.css";

// All Urls

class VideoMerge extends Component {
  constructor() {
    super();
    this.state = {
      fields: {},
      errors: {},
      countryList: [],
      getAllEvents: [],
      allSportsList: [],
      stateList: [],
      selectedCOuntry: "",
      countryId: null,
      stateid: "",

      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      country: "",
      state: "",
      schoolName: "",
      schoolType: "",
      sport: "",
      status: "",
      plan: "",
      anyMessage: "",
      selectedFile: null,
      fileAddress: null,
      uploadId: null,
      imagePreviewUrl: "",
    };

    this.getEventApi = this.getEventApi.bind(this);
  }


  getEventApi() {
    userService.getAllEventLibrary().then((res) => {
      var getAllEvents = res.data.data.eventMediaDetailsResponse;
      this.setState({ getAllEvents });
    });
  }

  // for popup
  openDialog() {
    this.setState({ open: !this.state.open });
  }

  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  componentDidMount() {
    this.getEventApi();
  }

  // for popup
  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const {open}=this.state;
    return (
      <div>
        <SchoolAdminDashboard />
        <div className="clear80"></div>
        <>
          <div className="row plr">
            <div className="col-md-12 col-lg-12 vid-box grey-border h52">
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <div className="clear10"></div>
                  <span className="fs-20 semi-bold dblack ml-3">LHS vs RHS: Playlist 1- 08/02/2021</span><span className="fs-20 regular txt-70">(5 Angles 100 Videos)</span>
                  <div className="clear10"></div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="row">
                    <div className="col-md-6 col-lg-6 text-right">
                      <div className="clear15"></div>
                      <span className="fs-16 semi-bold dblack mr-2">View Edited Videos Only</span>
                      <>
                      <div className='custom-control disin custom-switch'>
                      <input
                      type='checkbox'
                      className='custom-control-input olnone'
                      id='customSwitches'
                      readOnly
                      />
                      <label className='custom-control-label' htmlFor='customSwitches'>

                      </label>
                      </div>
                      </>
                    </div>
                    <div className="col-md-6 col-lg-6 text-right">
                      <button type="submit" className="mergbtn mt-2 mr-4"  onClick={this.openDialog.bind(this)}><span><img src={Mergeicon} className="mergeicostyle"></img></span>Merge</button>
                      <button
                        type="button"
                        className="vl-cancelbtn mr-2 mt-2"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="vl-savebtn mt-2 mr-4"
                        onClick={this.registerSchoolAdmin}
                      >
                        Save
                      </button>

                      {/* merge pop up */}

                      <Dialog
                      id="dialogBox" className="dialog-style editeventpopup"
                      open={open}
                      onClose={this.closeDialog.bind(this)}
                    >
                      <DialogTitle>
                        <div className="row">
                          <div className="col-1 text-right ml-auto ">
                            <BsXLg
                              onClick={this.closeDialog.bind(this)}
                              className="crossview cp"
                            ></BsXLg>
                          </div>
                        </div>
                      </DialogTitle>
                      <DialogContent>
                        <div className="clear10"></div>
                        <div className="row">
                          <div className="col-12 text-center">
                            <p className="fs-20 semi-bold text-center ">
                            Please enter a textfield for video merge.
                            </p>
                            <div className="clear10"></div>
                            <input type="text" className="mergebox mb-3"></input>
                          </div>
                          </div>
                          <div className="row">
                          <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-right mr-3">
                            <button
                              type="button"
                              class="cancelbtn"
                              onClick={this.closeDialog.bind(this)}
                            >
                              No
                            </button>
                          </div>
                          <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-left mr-3">
                            <Link to="/VideoMerge">
                              <button type="button" class="yes-btn">
                                Yes, Cancel
                              </button>
                            </Link>
                          </div>
                        </div>

                        <div className="clear10"></div>

                        <div className="clear10"></div>
                      </DialogContent>
                    </Dialog>
                      {/* end merge */}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="clear10"></div>
         <div className="clear10"></div>
        <div className="row plr">
          <div className="w-19 mx-auto">
            <select class="form-control ml-auto w-125 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>End Zone</option>
            <option>End Zone</option>
            </select>
            <div className="col-md-12 col-lg-12">
              <img className="img-fluid" src={endZoneImg} alt="EZ" />
            </div>
            <div className="clear5"></div>
            <div className="col-12 col-md-12 h-45">
              <div className="row">
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vlrefresh} alt="refresh" />
                </div>
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vldown} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlup} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlupdown} alt="down" />
                </div>
                <div className="d2 text-center">
                <div className="clear10"></div>
                  <img src={vldelete} alt="down" />
                </div>
              
              </div>
            </div>
            <div className="clear10"></div>
            <div className="col-md-12 col-lg-12">
            <div id="edit-Video-Table" class="table-responsive br11 brdcb">
            <table class="table table-hover m-0">
   
    <tbody>
      <tr>
        <td><img src={vlplay} alt="play" ></img> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
        <td><span>2</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
    </tbody>
  </table>
            </div>
            </div>
      
          </div>


          <div className="w-19 mx-auto">
          <select class="form-control ml-auto w-90 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>Other</option>
            <option>Other</option>
            </select>
            <div className="col-md-12 col-lg-12">
              <img className="img-fluid" src={endZoneImg} alt="EZ" />
            </div>
            <div className="clear5"></div>
            <div className="col-12 col-md-12 h-45">
              <div className="row">
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vlrefresh} alt="refresh" />
                </div>
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vldown} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlup} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlupdown} alt="down" />
                </div>
                <div className="d2 text-center">
                <div className="clear10"></div>
                  <img src={vldelete} alt="down" />
                </div>
              
              </div>
            </div>
            <div className="clear10"></div>
            <div className="col-md-12 col-lg-12">
            <div id="edit-Video-Table" class="table-responsive brdcb br11">
            <table class="table table-hover m-0">
   
    <tbody>
      <tr>
        <td><img src={vlplay} alt="play" ></img> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
        <td><span>2</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
    </tbody>
  </table>
            </div>
            </div>
          </div>
          <div className="w-19 mx-auto">
          <select class="form-control ml-auto w-90 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>Wide</option>
            <option>Wide</option>
            </select>
            <div className="col-md-12 col-lg-12">
              <img className="img-fluid" src={wide} alt="EZ" />
            </div>
            <div className="clear5"></div>
            <div className="col-12 col-md-12 h-45">
              <div className="row">
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vlrefresh} alt="refresh" />
                </div>
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vldown} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlup} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlupdown} alt="down" />
                </div>
                <div className="d2 text-center">
                <div className="clear10"></div>
                  <img src={vldelete} alt="down" />
                </div>
              
              </div>
            </div>
            <div className="clear10"></div>
            <div className="col-md-12 col-lg-12">
            <div id="edit-Video-Table" class="table-responsive brdcb br11">
            <table class="table table-hover m-0">
   
    <tbody>
      <tr>
        <td><img src={vlplay} alt="play" ></img> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
        <td><span>2</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
    </tbody>
  </table>
            </div>
            </div>
          </div>
          <div className="w-19 mx-auto">
          <select class="form-control ml-auto w-90 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>Tight</option>
            <option>Tight</option>
            </select>
            <div className="col-md-12 col-lg-12">
              <img className="img-fluid" src={vltight} alt="EZ" />
            </div>
            <div className="clear5"></div>
            <div className="col-12 col-md-12 h-45">
              <div className="row">
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vlrefresh} alt="refresh" />
                </div>
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vldown} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlup} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlupdown} alt="down" />
                </div>
                <div className="d2 text-center">
                <div className="clear10"></div>
                  <img src={vldelete} alt="down" />
                </div>
              
              </div>
            </div>
            <div className="clear10"></div>
            <div className="col-md-12 col-lg-12">
            <div id="edit-Video-Table" class="table-responsive brdcb br11">
            <table class="table table-hover m-0">
   
    <tbody>
      <tr>
        <td><img src={vlplay} alt="play" ></img> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
        <td><span>2</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
    </tbody>
  </table>
            </div>
            </div>
          </div>
          <div className="w-19 mx-auto">
          <select class="form-control ml-auto w-125 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>End Zone 2</option>
            <option>End Zone 2</option>
            </select>
            <div className="col-md-12 col-lg-12">
              <img className="img-fluid" src={endZoneImg} alt="EZ" />
            </div>
            <div className="clear5"></div>
            <div className="col-12 col-md-12 h-45">
              <div className="row">
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vlrefresh} alt="refresh" />
                </div>
                <div className="d1 text-center">
                  <div className="clear10"></div>
                  <img src={vldown} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlup} alt="down" />
                </div>
                <div className="d1 text-center">
                <div className="clear10"></div>
                  <img src={vlupdown} alt="down" />
                </div>
                <div className="d2 text-center">
                <div className="clear10"></div>
                  <img src={vldelete} alt="down" />
                </div>
              
              </div>
            </div>
            <div className="clear10"></div>
            <div className="col-md-12 col-lg-12">
            <div id="edit-Video-Table" class="table-responsive brdcb br11">
            <table class="table table-hover m-0">
   
    <tbody>
      <tr>
        <td><img src={vlplay} alt="play" ></img> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
        <td><span>2</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
            </select>
        </td>
        <td><span>0.13</span> </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
      <tr>
      <td><span>1</span> </td>
        <td className="padzero">
        <select class="form-control p-0 w100 olnone selectstyle fs-16 regular dblack" id="sel1" name="sellist1">
            <option>0.14</option>
            <option>0.14</option>
        </select>
        </td>
        <td>0.13 </td>
        <td id="vl">
        <label  class="container">
            <input type="checkbox" />
            <span class="checkmark"></span>
            </label> 
        </td>
      </tr>
    </tbody>
  </table>
            </div>
            </div>
          </div>
        </div>
       
        
               
       </>
      </div>
    );
  }
}

export default VideoMerge;
